/* eslint-disable functional/no-conditional-statement */

import { Dispatch, SetStateAction } from "react";
import { useDismissToast } from "../../common/hooks/useDismissToast";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import {
  BeginLoadingInput,
  FinishData,
  FinishErrors,
  FinishLoadingInput,
  State,
} from "../hooks/useAsyncLoader";

/**
 * Please use `FinishReturn` as the return type of the function that needs to dismiss the loading indicator.
 * DANGER: Do not export `FinishLoadingExhaustive` directly.
 * It must be unique to here to insure every code path exit dismisses the loading indicator.
 */
// eslint-disable-next-line functional/no-class
class FinishLoadingExhaustive {
  // id makes type non-equal to {} for type enforcement reasons
  // eslint-disable-next-line functional/prefer-readonly-type
  id = "d1208b63-0fea-4f66-b04b-8bca04ef634e";
  constructor() {
    // eslint-disable-next-line functional/no-this-expression
    this.id = "d1208b63-0fea-4f66-b04b-8bca04ef634e";
  }
}

export type FinishLoading<T> = (
  input: FinishLoadingInput<T>
) => FinishLoadingExhaustive;

export function finishWithSuccess<T>(
  input: FinishData<T>,
  setLoading: Dispatch<SetStateAction<State>>,
  setData: Dispatch<SetStateAction<"initial" | T>>,
  beginLoadingInput: BeginLoadingInput | undefined,
  key: DataTestids,
  dismissToast: ReturnType<typeof useDismissToast>
) {
  if (beginLoadingInput?.finishCallback) {
    beginLoadingInput.finishCallback();
  }

  setData(input.data);
  setLoading({ tag: "success", key });
  dismissToast(key);
  return new FinishLoadingExhaustive();
}

export function finishWithErrors(
  input: FinishErrors,
  setLoading: Dispatch<SetStateAction<State>>,
  beginLoadingInput: BeginLoadingInput | undefined,
  key: DataTestids
) {
  if (beginLoadingInput?.errorsCallback) {
    beginLoadingInput.errorsCallback(input.errors);
  }
  if (beginLoadingInput?.finishCallback) {
    beginLoadingInput.finishCallback();
  }
  setLoading({ tag: "errors", errors: input.errors, uuid: input.uuid, key });
  return new FinishLoadingExhaustive();
}
